import PropTypes from 'prop-types';

export default class LookBookDropDown extends React.Component {
    static propTypes = {
        lookBookCntrlHandler: PropTypes.func,
        onSelectLookBookItem: PropTypes.func,
        onSelectCombination: PropTypes.func,
        isDDLOpen: PropTypes.bool,
        isSelectionCombination: PropTypes.bool,
        selectedInspiration: PropTypes.object,
        inspirationsData: PropTypes.array,
        willRenderDropDown: PropTypes.bool
    };
    static defaultProps = {
        lookBookCntrlHandler: () => null,
        onSelectLookBookItem: () => null,
        onSelectCombination: () => null,
        isDDLOpen: false,
        isSelectionCombination: false,
        selectedInspiration: {},
        inspirationsData: [],
        willRenderDropDown: false
    };
    constructor() {
        super();
    }
    _renderInspirationListItem = (inspiration) => {

        return (
            <li key={inspiration.id} id={`${inspiration.id}`} className={`${(this.props.selectedInspiration.id === inspiration.id) ? 'selected' : ''}`} onClick = { this.props.onSelectLookBookItem } >
                <span>{inspiration.name}</span>
                <small className="display-block">INSPIRATION</small>
            </li>
        );
    };
    render() {

        if (!this.props.willRenderDropDown) {
            return (
                <div className="txt-center look-book-no-dropdown-ttl">
                    <span className="display-block be-inspired-copy font-italic">Be Inspired by our</span>
                    <h2>Look Books</h2>
                </div>
            );
        }

        return (
            <div className="dropdown-wrapper">
                <p className="ddl-text look-book-ddl-cntrl" onClick = { this.props.lookBookCntrlHandler } >{`${this.props.selectedInspiration.name}${(this.props.isSelectionCombination) ? ' Combination' : ''}`}</p>
                <div className={`look-book-ddl-content ${(this.props.isDDLOpen) ? 'active' : null} txt-center`}>
                    <div className="col-xs-12 col-sm-6">
                        <h5 className="look-book-list-ttl">Inspirations</h5>
                        <ul className="look-book-list inspirations">
                            {
                                this.props.inspirationsData.map( (inspiration) => this._renderInspirationListItem(inspiration) )
                            }
                        </ul>
                    </div>
                    <div className="col-xs-12 col-sm-6 combinations-wrapper">
                        <h5 className="look-book-list-ttl">Combinations</h5>
                        <ul className="look-book-list combinations">
                            <li id="passion" className={`${(this.props.selectedInspiration.id === 'passion') ? 'selected' : ''}`} onClick={ this.props.onSelectCombination }>
                                <span>INSPIRED BY PASSION</span>
                                <small className="display-block">COMBINATION</small>
                            </li>
                            <li id="gardens" className={`${(this.props.selectedInspiration.id === 'gardens') ? 'selected' : ''}`} onClick={ this.props.onSelectCombination }>
                                <span>INSPIRED BY GARDENS</span>
                                <small className="display-block">COMBINATION</small>
                            </li>
                            <li id="romance" className={`${(this.props.selectedInspiration.id === 'romance') ? 'selected' : ''}`} onClick={ this.props.onSelectCombination }>
                                <span>INSPIRED BY ROMANCE</span>
                                <small className="display-block">COMBINATION</small>
                            </li>
                        </ul>
                        <p className="combinations-info txt-center pr"><big>Combinations are created</big> using curated items from various inspirations to create a unique concept tailored for you.</p>
                    </div>
                </div>
            </div>
        );
    }
}
